// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Cupones_container__3\\+X3W {
  justify-content: center;
}

.Cupones_container__3\\+X3W .Cupones_titleContainer__fotz7 {
  animation: Cupones_init__HdbT- 0.5s both;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.Cupones_container__3\\+X3W .Cupones_titleContainer__fotz7 h4 {
  font-size: 1.6rem;
  font-weight: 300;
  margin-left: 10px;
}

.Cupones_container__3\\+X3W .Cupones_tableContainer__YV5JE {
  max-height: 80vh;
  animation: Cupones_init__HdbT- 0.5s both;
  border-radius: 5px;
  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);
}

@keyframes Cupones_init__HdbT- {
  0% {
    opacity: 0;
    transform: translateX(-20px);
  }

  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/Cupones/index.module.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;;AAEA;EACE,wCAAyB;EACzB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,wCAAyB;EACzB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":[".container {\n  justify-content: center;\n}\n\n.container .titleContainer {\n  animation: init 0.5s both;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.container .titleContainer h4 {\n  font-size: 1.6rem;\n  font-weight: 300;\n  margin-left: 10px;\n}\n\n.container .tableContainer {\n  max-height: 80vh;\n  animation: init 0.5s both;\n  border-radius: 5px;\n  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n    transform: translateX(-20px);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Cupones_container__3+X3W`,
	"titleContainer": `Cupones_titleContainer__fotz7`,
	"init": `Cupones_init__HdbT-`,
	"tableContainer": `Cupones_tableContainer__YV5JE`
};
export default ___CSS_LOADER_EXPORT___;
